
/**
 * @roxi/routify 2.18.17
 * File generated Tue Mar 17 2026 10:36:57 GMT+0100 (Central European Standard Time)
 */

export const __version = "2.18.17"
export const __timestamp = "2026-03-17T09:36:57.914Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes.js"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/admin/ciselniky",
          "id": "_admin_ciselniky",
          "component": () => import('../src/pages/admin/ciselniky.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/externiste",
          "id": "_admin_externiste",
          "component": () => import('../src/pages/admin/externiste.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/formulare",
          "id": "_admin_formulare",
          "component": () => import('../src/pages/admin/formulare.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/funkce",
          "id": "_admin_funkce",
          "component": () => import('../src/pages/admin/funkce.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/historie",
          "id": "_admin_historie",
          "component": () => import('../src/pages/admin/historie.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/komise",
          "id": "_admin_komise",
          "component": () => import('../src/pages/admin/komise.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/naplanovane",
          "id": "_admin_naplanovane",
          "component": () => import('../src/pages/admin/naplanovane.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/nastaveni",
          "id": "_admin_nastaveni",
          "component": () => import('../src/pages/admin/nastaveni.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/odeslane",
          "id": "_admin_odeslane",
          "component": () => import('../src/pages/admin/odeslane.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/osoby",
          "id": "_admin_osoby",
          "component": () => import('../src/pages/admin/osoby.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/sablony",
          "id": "_admin_sablony",
          "component": () => import('../src/pages/admin/sablony.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/vystupy",
          "id": "_admin_vystupy",
          "component": () => import('../src/pages/admin/vystupy.svelte').then(m => m.default)
        }
      ],
      "path": "/admin"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/czv/:id",
          "id": "_czv__id",
          "component": () => import('../src/pages/czv/[id].svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/czv/create",
          "id": "_czv_create",
          "component": () => import('../src/pages/czv/create.svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/czv/index",
          "id": "_czv_index",
          "component": () => import('../src/pages/czv/index.svelte').then(m => m.default)
        }
      ],
      "path": "/czv"
    },
    {
      "isDir": true,
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/externiformular/index",
          "id": "_externiformular_index",
          "component": () => import('../src/pages/externiformular/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": true,
      "isReset": true,
      "path": "/externiformular",
      "id": "_externiformular__reset",
      "component": () => import('../src/pages/externiformular/_reset.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/externiste",
      "id": "_externiste",
      "component": () => import('../src/pages/externiste.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "children": [
        {
          "isIndex": true,
          "isPage": true,
          "path": "/formular/index",
          "id": "_formular_index",
          "component": () => import('../src/pages/formular/index.svelte').then(m => m.default)
        }
      ],
      "isLayout": true,
      "isReset": true,
      "path": "/formular",
      "id": "_formular__reset",
      "component": () => import('../src/pages/formular/_reset.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/hodnoceni/:id",
          "id": "_hodnoceni__id",
          "component": () => import('../src/pages/hodnoceni/[id].svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/hodnoceni/index",
          "id": "_hodnoceni_index",
          "component": () => import('../src/pages/hodnoceni/index.svelte').then(m => m.default)
        }
      ],
      "path": "/hodnoceni"
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => import('../src/pages/index.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/komise",
      "id": "_komise",
      "component": () => import('../src/pages/komise.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/kzo/:id",
          "id": "_kzo__id",
          "component": () => import('../src/pages/kzo/[id].svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/kzo/index",
          "id": "_kzo_index",
          "component": () => import('../src/pages/kzo/index.svelte').then(m => m.default)
        }
      ],
      "path": "/kzo"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/pripravovane/:id",
          "id": "_pripravovane__id",
          "component": () => import('../src/pages/pripravovane/[id].svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/pripravovane/create",
          "id": "_pripravovane_create",
          "component": () => import('../src/pages/pripravovane/create.svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/pripravovane/index",
          "id": "_pripravovane_index",
          "component": () => import('../src/pages/pripravovane/index.svelte').then(m => m.default)
        }
      ],
      "path": "/pripravovane"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/ukoncene/:id",
          "id": "_ukoncene__id",
          "component": () => import('../src/pages/ukoncene/[id].svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/ukoncene/index",
          "id": "_ukoncene_index",
          "component": () => import('../src/pages/ukoncene/index.svelte').then(m => m.default)
        }
      ],
      "path": "/ukoncene"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/uzavrene/:id",
          "id": "_uzavrene__id",
          "component": () => import('../src/pages/uzavrene/[id].svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/uzavrene/index",
          "id": "_uzavrene_index",
          "component": () => import('../src/pages/uzavrene/index.svelte').then(m => m.default)
        }
      ],
      "path": "/uzavrene"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/zadostiia/:id",
          "id": "_zadostiia__id",
          "component": () => import('../src/pages/zadostiia/[id].svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/zadostiia/create",
          "id": "_zadostiia_create",
          "component": () => import('../src/pages/zadostiia/create.svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/zadostiia/index",
          "id": "_zadostiia_index",
          "component": () => import('../src/pages/zadostiia/index.svelte').then(m => m.default)
        }
      ],
      "path": "/zadostiia"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/zadostinau/:id",
          "id": "_zadostinau__id",
          "component": () => import('../src/pages/zadostinau/[id].svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/zadostinau/create",
          "id": "_zadostinau_create",
          "component": () => import('../src/pages/zadostinau/create.svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/zadostinau/index",
          "id": "_zadostinau_index",
          "component": () => import('../src/pages/zadostinau/index.svelte').then(m => m.default)
        }
      ],
      "path": "/zadostinau"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/ziskane/:id",
          "id": "_ziskane__id",
          "component": () => import('../src/pages/ziskane/[id].svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/ziskane/index",
          "id": "_ziskane_index",
          "component": () => import('../src/pages/ziskane/index.svelte').then(m => m.default)
        }
      ],
      "path": "/ziskane"
    }
  ],
  "isLayout": true,
  "path": "/",
  "id": "__layout",
  "component": () => import('../src/pages/_layout.svelte').then(m => m.default)
}


export const {tree, routes} = buildClientTree(_tree)

